<template>
  <div class="flex flex-col w-full relative justify-start pt-4  mx-2">        
    <div class="flex !grow-0 gap-4 items-end">
        <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Fleet.Manager') }} :</div>
        <v-text-field hide-details v-model="modified.param.manager" />
    </div> 
    <div class="flex !grow-0 gap-4 items-end">
        <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Fleet.Phone') }} :</div>
        <v-text-field hide-details v-model="modified.param.phone" />
    </div> 
    <h3 class="mt-2">{{ $t('Fleet.ArgosRef') }}</h3>
    <div class="flex !grow-0 gap-4 items-end" v-for="(misId,idx) in modified.MISSION_IDS">
        <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ store.myGetters.missionsById[misId].misLibelle }} :</div>
        <v-text-field hide-details v-model="modified.param.argos[misId]" />
    </div> 
    <hr class="w-full mt-4 text-gray-300"/>
    <div class="flex shrink-0 !grow-0 w-full  items-center gap-2">                          
      <v-btn :disabled="!btnActif" @click="saveConfig()" small color="primary" class="ml-auto !grow-0" >{{$t('Pilot.MissionPlan.PublishStagingToIris')}}<v-icon small right >mdi-content-save</v-icon></v-btn>      
    </div>    
  </div>  
</template>
<script setup lang="ts">
 
  import { ref,computed, watch, nextTick } from 'vue'  
  import store from '@/store'   
  import { AloDbFleet } from '@/models/alodb/AloDbFleet'
  import deepEqual from 'deep-equal' 

 const props = defineProps<{
   fleet:AloDbFleet, 
   isleft:boolean,
   uiid:string, 
   isVisible:boolean
 }>()

 
 const modified = computed(() => store.myGetters.modifiedAdmAdminFleet as AloDbFleet)
 const original = computed(() => store.myGetters.originalAdmAdminFleet as AloDbFleet)    

 const btnActif = computed(() => !deepEqual(original.value, modified.value) /*&& !editCoverageState.value!.saving*/)
  

 async function saveConfig() {     
    await store.myActions.ADMINFLEET_SAVE_REQUEST()    
  }


</script>